function roundUpToNearestUnit(seconds, unit) {
  const unitsInSeconds = {
    minutes: 60,
    hours: 3600,
    days: 86400
  };
  const unitInSeconds = unitsInSeconds[unit];
  if (!unitInSeconds) return 0;
  return Math.ceil(seconds / unitInSeconds) * unitInSeconds;
}
export {
  roundUpToNearestUnit
};
